/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slim_Bold_Crow_CallInputs */

const en_slim_bold_crow_call = /** @type {(inputs: Slim_Bold_Crow_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to restore version`)
};

const de_slim_bold_crow_call = /** @type {(inputs: Slim_Bold_Crow_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version konnte nicht wiederhergestellt werden`)
};

/**
* | output |
* | --- |
* | "Failed to restore version" |
*
* @param {Slim_Bold_Crow_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slim_bold_crow_call = /** @type {((inputs?: Slim_Bold_Crow_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slim_Bold_Crow_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_slim_bold_crow_call(inputs)
	return de_slim_bold_crow_call(inputs)
});